/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { MdHome } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import './FlightHotelPassengerCalender.scss';
import getYear from 'date-fns/getYear';
import getMonth from 'date-fns/getMonth';
import getDate from 'date-fns/getDate';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import {
  NAVIGATION_ROUTES,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import { getFlightPaxCalendarApi } from '../../api/flightApi';
import AppLink from '../../shared/components/app-link/AppLink';
import { getHotelPaxCalendarApi } from '../../api/hotelApi';
import {
  getNewDate,
  hideHeaderFooterInMobile,
  isMobileWidth,
  showHeaderFooterInMobile,
} from '../../shared/helper-utils/appUtils';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';

function FlightHotelPassengerCalendar() {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(getNewDate(TODAY_DATE));
  const [years, setYears] = useState([]);
  const [type, setType] = useState('Flight');
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  useEffect(() => {
    hideHeaderFooterInMobile();
    return () => showHeaderFooterInMobile();
  }, []);

  const getTransactionsData = async (month, year) => {
    setIsLoading(true);
    const agentId = getUserAgentId();
    if (month === undefined || year === undefined) {
      year = getYear(selectedDate);
      month = getMonth(selectedDate) + 1;
    }
    let response = [];
    if (type === 'Hotel') {
      response = await getHotelPaxCalendarApi(agentId, month, year);
      if (response && response.Root && response.Root.Result) {
        const { Result } = response.Root;
        const { HotelInvoice } = Result;
        if (HotelInvoice !== '') {
          const events = Array.isArray(HotelInvoice)
            ? HotelInvoice
            : [HotelInvoice];
          setTransactions(events);
        } else {
          setTransactions([]);
        }
      } else {
        setTransactions([]);
      }
    } else {
      response = await getFlightPaxCalendarApi(agentId, month, year);
      if (response && response.Root && response.Root.Result) {
        const { Result } = response.Root;
        const { FlightRecord } = Result;
        if (FlightRecord !== '') {
          const events = Array.isArray(FlightRecord)
            ? FlightRecord
            : [FlightRecord];
          setTransactions(events);
        } else {
          setTransactions([]);
        }
      } else {
        setTransactions([]);
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const currentYear = getYear(getNewDate(TODAY_DATE));
    const list = [];
    for (let i = 0; i < 10; i += 1) {
      list.push(currentYear + i);
      list.push(currentYear - i);
    }
    setYears(list);
    getTransactionsData();
  }, []);

  const handleMonthChange = (date) => {
    const month = getMonth(date);
    const year = getYear(date);
    getTransactionsData(month + 1, year);
  };

  const getNavigationRoute = (txId) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_ORDER_DETAILS;
    route = route.replace(':transactionId', txId);
    return route;
  };

  const renderDayContents = (day, date) => {
    return (
      <div className="train-events">
        <div className="cal-date">{getDate(date)}</div>
        <div className="train-event">
          {transactions.length > 0 &&
            transactions.map((transaction) => (
              <React.Fragment key={transaction.Txid}>
                {type === 'Flight' &&
                getDate(getNewDate(transaction.JDate)) === getDate(date) &&
                getMonth(getNewDate(transaction.JDate)) === getMonth(date) ? (
                  <AppLink
                    linkText={`${transaction.PassengerFirstName} ${transaction.PassengerLastName} (${transaction.Origin} -> ${transaction.Destination})(${transaction.BookingStatus})`}
                    isLink
                    href={getNavigationRoute(transaction.Txid)}
                    target="_blank"
                  />
                ) : null}
                {type === 'Hotel' &&
                getDate(getNewDate(transaction.checkin_time)) ===
                  getDate(date) &&
                getMonth(getNewDate(transaction.checkin_time)) ===
                  getMonth(date) ? (
                  <AppLink
                    linkText={`${transaction.leadpassenger_firstname} ${transaction.leadpassenger_lastname} (${transaction.hotel_name})`}
                    isLink
                    href={getNavigationRoute(transaction.txid)}
                    target="_blank"
                  />
                ) : null}
              </React.Fragment>
            ))}
        </div>
      </div>
    );
  };

  return (
    <section className="train-passenger-calendar-page">
      {isLoading && <AppLoading isLoading={isLoading} />}
      {!isMobileWidth() ? (
        <div className="train-passenger-calendar-page__header">
          <h5 className="mt-3 mb-3">{type} Passenger Calendar</h5>
        </div>
      ) : (
        <div
          className="modify-search-container show-for-599px"
          style={{ position: 'sticky', top: '0', zIndex: '10' }}
        >
          <div className="d-flex">
            <AppIconButton
              onClick={() => navigate('/')}
              className="white-color"
              variant="transparent"
            >
              <MdHome />
            </AppIconButton>
            <div className="d-flex justify-content-between p-2 align-items-center flex-1">
              <div className="fs-14 white-color">{type} Passenger Calendar</div>
            </div>
          </div>
        </div>
      )}

      <div className="train-passenger-calendar-page__body  overflow-auto">
        <DatePicker
          inline
          renderCustomHeader={({
            date,
            changeYear,
            changeMonth,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => (
            <div
              style={{
                margin: 10,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <select
                value={type}
                onChange={({ target: { value } }) => {
                  setType(value);
                }}
              >
                <option value="Flight">Flight</option>
                <option value="Hotel">Hotel</option>
              </select>
              <button
                type="button"
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
              >
                Previous Month
              </button>
              <select
                value={getYear(date)}
                onChange={({ target: { value } }) => {
                  changeYear(value);
                }}
              >
                {years.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <select
                value={months[getMonth(date)]}
                onChange={({ target: { value } }) => {
                  changeMonth(months.indexOf(value));
                }}
              >
                {months.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <button
                type="button"
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
              >
                Next Month
              </button>
            </div>
          )}
          renderDayContents={renderDayContents}
          selected={selectedDate}
          onMonthChange={(date) => handleMonthChange(date)}
          onYearChange={(date) => handleMonthChange(date)}
          onChange={(date) => setSelectedDate(date)}
        />
      </div>
    </section>
  );
}

export default FlightHotelPassengerCalendar;
